import React, { useEffect } from 'react';
import {
    PromoSection,
    InfoBlock,
    AboutCourses,
    TeamSection,
    // Directions,
} from './components';
import { CooperationForm } from 'components';
import { useMobileMenuContext } from 'contexts/mobile-menu.context';

export const About: React.FC = (): JSX.Element => {
    const { toggleProfessionStyles } = useMobileMenuContext();

    useEffect(() => {
        toggleProfessionStyles(true);

        return () => {
            toggleProfessionStyles(false);
        };
    }, []);

    return (
        <>
            <PromoSection />
            <InfoBlock />
            {/* <Directions /> */}
            <AboutCourses />
            <TeamSection />
            <CooperationForm />
        </>
    );
};

export default About;
